<template>
  <div>
    <v-row no-gutters>
      <v-col class="py-3">
        <div class="suggetion_text__class">Suggestions</div>
        <v-divider></v-divider>
      </v-col>
      <v-col
        cols="12"
        v-for="(item, i) in items"
        :key="i"
        class="d-flex"
        :style="getSelected(item) ? 'background: #d8d8d8' : ''"
        @click="selecteVideo(item)"
      >
        <v-icon v-if="item.id == value.id">mdi-play</v-icon>
        <video-list :value="item"></video-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "SuggestedVideos",
  components: {
    VideoList: () => import("../VideoList/VideoList.vue"),
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    getSelected(item) {
      return parseInt(this.value.id) === parseInt(item.id);
    },
    selecteVideo(item) {
      this.$emit("input", item);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.suggetion_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #333333;
}
.video_count_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  color: #5b5b5b;
}
@media all and (max-width: 600px) {
  .suggetion_text__class {
    margin-left: 10px;
  }
}
</style>
